import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListManageRules from '../../components/ruleset/list-manage-rules.component';

const ManageRules = () => {
  const pageTitle = 'Schedule Videos / Rules Library';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListManageRules />
    </AppLayout>
  );
};

export default ManageRules;
